import api from "../../utils/API";

const getPilotageConsultants = (queryParams) => {
    return api.get(`/gestion/pilotage/consultants/list${queryParams}`);
}

const getPilotageClients = (queryParams) => {
    return api.get(`/gestion/pilotage/clients/list${queryParams}`);
}

const getPilotageCommercial = (queryParams) => {
    return api.get(`/gestion/pilotage/commercial/list${queryParams}`);
}

const exportPilotageCommercial = (startDate, endDate, selectedConsultants) => {
    console.log({ startDate, endDate, selectedConsultants });
    return api.get(`/gestion/pilotage/commercial/export`,
        {
            params: { startDate, endDate, consultants: selectedConsultants },
            responseType: "blob",
        })
}

const getPilotageConsultantsDetail = (queryParams) => {
    return api.get(`/gestion/pilotage/consultants/detail${queryParams}`);
}

const getPilotageClientsDetail = (queryParams) => {
    return api.get(`/gestion/pilotage/clients/detail${queryParams}`);
}

export {
    exportPilotageCommercial, getPilotageClients, getPilotageClientsDetail, getPilotageCommercial, getPilotageConsultants, getPilotageConsultantsDetail
};

